export default __webpack_public_path__ + "2423cc2d4d945743a37778b7e1590335.png";